import Driver from 'driver.js'
import 'driver.js/dist/driver.min.css'

export const driver = {
  computed: {
    driver: function () {
      return new Driver({
        stageBackground: 'black',
        animate: false
      })
    }
  }
}
